import {
    Drawer,
    Table,
    Icon,
    Tag,
    Card,
    notification,
    Button,
    Tooltip,
    Input,
    DatePicker
} from "antd";
import React from "react";
import { connect } from "react-redux";
import Request, { MEDIA_URL } from "../../request";
import FileViewer from "react-file-viewer";
import { TableComp } from "sz-react-utils";
const { RangePicker } = DatePicker;

/* ==============================
Agreement Preview Drawer
================================ */
class ShowUniversityAgreement extends React.Component {
    state = { visible: true };

    onError = () => {
        notification.error({
            message: "File type not supported, try downloading it."
        });
        this.close();
    };

    close = () => {
        this.setState({ visible: false });
        setTimeout(() => this.props.onClose(), 300);
    };



    render() {
        const { record } = this.props;
        const { visible } = this.state;

        return (
            <Drawer
                title="University Agreement"
                placement="right"
                onClose={this.close}
                visible={visible}
                width={800}
            >
                <Card>
                    <FileViewer
                        fileType="pdf"
                        filePath={`${MEDIA_URL}${record && record[0] ? record[0].url : ""}`}
                        onError={this.onError}
                    />
                </Card>
            </Drawer>
        );
    }
}

/* ==============================
Main Approval Drawer
================================ */
class UniversityCommApprovalDrawer extends React.Component {
    state = {
        visible: true,
        loading: false,
        count: 0,
        arr: [],
        showAgreementDrawer: false,
        agreementRecord: null,
        currentPage: 1,
        pageSize: 10
    };

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ loading: true });

            try {
                const res = await Request.getPendingUniversityCommApproval(params);
                this.setState({
                    arr: res && res.data ? res.data : [],
                    count: res && res.total ? res.total : 0
                })
                return resolve(res);
            } catch (e) {
                notification.error({ message: "Failed to load data" });
            } finally {
                this.setState({ loading: false });
            }
        })
    }

    componentDidMount() {
        // this.loadApis();
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => this.props.onClose(), 300);
    };


    /* ==============================
    API Loader (SAFE)
    ================================ */
    loadApis = async (params = {}) => {
        this.setState({ loading: true });

        try {
            const res = await Request.getPendingUniversityCommApproval(params);
            this.setState({
                arr: res && res.data ? res.data : [],
                count: res && res.total ? res.total : 0
            });
        } catch (e) {
            notification.error({ message: "Failed to load data" });
        } finally {
            this.setState({ loading: false });
        }
    };

    /* ==============================
    Approve / Disapprove
    ================================ */
    updateUniversityAgreement = async (id, status) => {

        const { arr } = this.state;
        const record = arr.find(item => item._id === id);
        if (!record) return;

        this.setState({ loading: true });

        const payload = {
            _id: record._id,
            universityId: record.universityId,
            status
        };

        if (record.channelPartnerId) {
            payload.channelPartnerId = record.channelPartnerId;
        }

        try {
            const res = await Request.updateUniversityCommissionStatus(payload);

            if (res && res.success) {
                notification.success({ message: res.message });
                this.table.current.reload();
            } else {
                notification.error({ message: res.message || "Action failed" });
            }
        } catch (e) {
            notification.error({ message: "Something went wrong" });
        } finally {
            this.setState({ loading: false });
        }
    };

    /* ==============================
    Agreement Drawer
    ================================ */
    openAgreement = record => {
        this.setState({
            showAgreementDrawer: true,
            agreementRecord: record
        });
    };

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => confirm()}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                    onClick={() => confirm()}
                >
                    Search
                </Button>
                <Button
                    size="small"
                    style={{ width: 90 }}
                    onClick={() => clearFilters()}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false
    });

    closeAgreement = () => {
        this.setState({
            showAgreementDrawer: false,
            agreementRecord: null
        });
    };

    render() {
        const { title, bgColorClass, icon } = this.props.param;
        const {
            visible,
            loading,
            count,
            arr,
            showAgreementDrawer,
            agreementRecord
        } = this.state;

        // const columns = [
        //     {
        //         title: "Sr.",
        //         width: 60,
        //         fixed: "left",
        //         render: (_, __, index) => index + 1
        //     },
        //     {
        //         title: "Action",
        //         width: 120,
        //         fixed: "left",
        //         render: (_, record) => (
        //             <>
        //                 <Tooltip title="Approve">
        //                     <Button
        //                         size="small"
        //                         shape="circle"
        //                         icon="check"
        //                         loading={loading}
        //                         onClick={() =>
        //                             this.updateUniversityAgreement(record._id, "Active")
        //                         }
        //                     />
        //                 </Tooltip>
        //                 <Tooltip title="Disapprove">
        //                     <Button
        //                         size="small"
        //                         shape="circle"
        //                         icon="close"
        //                         style={{ marginLeft: 5 }}
        //                         loading={loading}
        //                         onClick={() =>
        //                             this.updateUniversityAgreement(record._id, "Inactive")
        //                         }
        //                     />
        //                 </Tooltip>
        //             </>
        //         )
        //     },
        //     {
        //         title: "University Name",
        //         dataIndex: "universityInstitutionName",
        //         key: "universityInstitutionName",
        //         render: text => text || "-",
        //         ...this.getColumnSearchProps("universityInstitutionName")
        //     },
        //     {
        //         title: "Partnership",
        //         render: r => (r.channelPartnerId ? "Channel Partner" : "Direct")
        //     },
        //     {
        //         title: "CP Name",
        //         render: r => r.channelPartnerName || "-"
        //     },
        //     {
        //         title: "Commission Type",
        //         render: r => r.commissionTypeFrom || "-"
        //     },
        //     {
        //         title: "Commission",
        //         render: r => r.commissionFromUniversity || "-"
        //     },
        //     {
        //         title: "Invoices",
        //         render: r => r.noOfInvoice || "-"
        //     },
        //     {
        //         title: "Invoice / Year",
        //         render: r => r.invoicePerYear || "-"
        //     },
        //     {
        //         title: "Full Agreement",
        //         width: 120,
        //         render: r =>
        //             r.paymentUpload && r.paymentUpload.length ? (
        //                 <Button
        //                     icon="eye"
        //                     onClick={() => this.openAgreement(r.paymentUpload)}
        //                 />
        //             ) : (
        //                 "NA"
        //             )
        //     },
        //     {
        //         title: "Commission Page",
        //         width: 120,
        //         render: r =>
        //             r.paymentUploadCommissionPage &&
        //                 r.paymentUploadCommissionPage.length ? (
        //                 <Button
        //                     icon="eye"
        //                     onClick={() =>
        //                         this.openAgreement(r.paymentUploadCommissionPage)
        //                     }
        //                 />
        //             ) : (
        //                 "NA"
        //             )
        //     }
        // ];
        const columns = [
            {
                title: "Sr.",
                width: 60,
                fixed: "left",
                render: function (_, __, index) {
                    return index + 1;
                }
            },
            {
                title: "Action",
                width: 120,
                fixed: "left",
                render: (_, record) => (
                    <>
                        <Tooltip title="Approve">
                            <Button
                                size="small"
                                shape="circle"
                                icon="check"
                                loading={loading}
                                onClick={() =>
                                    this.updateUniversityAgreement(record._id, "Active")
                                }
                            />
                        </Tooltip>
                        <Tooltip title="Disapprove">
                            <Button
                                size="small"
                                shape="circle"
                                icon="close"
                                style={{ marginLeft: 5 }}
                                loading={loading}
                                onClick={() =>
                                    this.updateUniversityAgreement(record._id, "Inactive")
                                }
                            />
                        </Tooltip>
                    </>
                )
            },
            {
                title: "University Name",
                dataIndex: "universityInstitutionName",
                key: "universityInstitutionName",

                render: function (text) {
                    return text || "-";
                },

                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder="Search University"
                            value={selectedKeys[0] || ""}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                            }}
                            style={{ marginBottom: 8, display: "block" }}
                            onPressEnter={() => {
                                confirm();

                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        />

                        <Button
                            type="primary"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                            onClick={() => {
                                confirm();

                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Search
                        </Button>

                        <Button
                            size="small"
                            style={{ width: 90 }}
                            onClick={() => {
                                clearFilters();

                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Reset
                        </Button>
                    </div>
                ),

                filterIcon: function (filtered) {
                    return (
                        <Icon
                            type="search"
                            style={{ color: filtered ? "#1890ff" : undefined }}
                        />
                    );
                }
            },
            {
                title: "CP Name",
                render: function (r) {
                    return r.channelPartnerName || "-";
                }
            },
            {
                title: "Base / Special",
                dataIndex: "typeOfCommission",
                key: "typeOfCommission",
                render: function (text) {
                    return text || "-";
                }
            },
            // {
            //     title: "Commission Type",
            //     render: function (r) {
            //         if (r.commissionTypeFrom) {
            //             return r.commissionTypeFrom;
            //         }

            //         if (r.commDetails && r.commDetails.length > 0) {
            //             return (
            //                 <div>
            //                     {r.commDetails.map(function (item, index) {
            //                         return (
            //                             <div key={index}>
            //                                 {"T" + (item.term || index + 1) + ": " + (item.commissionTypeFrom || "-")}
            //                             </div>
            //                         );
            //                     })}
            //                 </div>
            //             );
            //         }

            //         return "-";
            //     }
            // },
            {
                title: "Commission",
                render: function (r) {

                    // ✅ FIRST PRIORITY: commDetails
                    if (r.commDetails && r.commDetails.length > 0) {
                        return (
                            <div>
                                {r.commDetails.map(function (item, index) {
                                    var commissionValue = "-";
                                    var commissionType = item.commissionTypeFrom === "Percentage" ? "(%)" : item.commissionTypeFrom === "Flat" ? "(Flat)" : "";
                                    if (
                                        item.commissionFromUniversity !== undefined &&
                                        item.commissionFromUniversity !== null &&
                                        item.commissionFromUniversity !== ""
                                    ) {
                                        commissionValue = item.commissionFromUniversity;
                                    }


                                    return (
                                        <div key={index}>
                                            {"T" + (item.term || index + 1) + ": " + commissionValue + commissionType}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    }

                    if (
                        r.commissionFromUniversity !== undefined &&
                        r.commissionFromUniversity !== null &&
                        r.commissionFromUniversity !== ""
                    ) {
                        return (
                            r.commissionFromUniversity +
                            (r.commissionTypeFrom === "Percentage"
                                ? " (%)"
                                : r.commissionTypeFrom === "Flat"
                                    ? " (Flat)"
                                    : "")
                        );
                    }

                    return "-";
                }
            },
            {
                title: "Invoices",
                render: function (r) {
                    if (
                        r.noOfInvoice !== undefined &&
                        r.noOfInvoice !== null &&
                        r.noOfInvoice !== ""
                    ) {
                        return r.noOfInvoice;
                    }
                    return "-";
                }
            },
            {
                title: "Invoice / Year",
                render: function (r) {
                    if (
                        r.invoicePerYear !== undefined &&
                        r.invoicePerYear !== null &&
                        r.invoicePerYear !== ""
                    ) {
                        return r.invoicePerYear;
                    }
                    return "-";
                }
            },
            {
                title: "Bonus Details",
                render: function (r) {

                    function getStudentRange(b) {
                        if (b.minimumStudents || b.maximumStudents) {
                            return (b.minimumStudents || 0) + "-" + (b.maximumStudents || "∞");
                        }

                        if (b.totalStudents) {
                            return "0-" + b.totalStudents;
                        }

                        return "N/A";
                    }

                    function formatBonus(b) {
                        return (
                            getStudentRange(b) +
                            " : " +
                            b.bonus +
                            (
                                b.commissionType === "percentage" ||
                                    b.commissionType === "percantage"
                                    ? " %"
                                    : ""
                            )
                        );
                    }

                    // ==========================
                    // PRIORITY 1 : commDetails
                    // ==========================
                    if (r && r.commDetails && r.commDetails.length > 0) {

                        var validTerms = r.commDetails
                            .filter(function (item) {
                                return (
                                    item &&
                                    item.bonusAny === "Yes" &&
                                    item.bonusDetails &&
                                    item.bonusDetails.length > 0
                                );
                            })
                            .sort(function (a, b) {
                                return (a.term || 0) - (b.term || 0);
                            });

                        if (validTerms.length === 0) {
                            return "N/A";
                        }

                        return (
                            <div>
                                {validTerms.map(function (item, index) {

                                    var sortedBonus = item.bonusDetails
                                        .slice()
                                        .sort(function (a, b) {
                                            return (
                                                (a.minimumStudents || a.totalStudents || 0) -
                                                (b.minimumStudents || b.totalStudents || 0)
                                            );
                                        });

                                    return (
                                        <div key={index} style={{ marginBottom: 8 }}>
                                            <b>{"T" + (item.term || index + 1)}</b>

                                            {sortedBonus.map(function (b, i) {
                                                return (
                                                    <div key={i} style={{ marginLeft: 10 }}>
                                                        {formatBonus(b)}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    }

                    // ==========================
                    // PRIORITY 2 : OLD STRUCTURE
                    // ==========================
                    if (
                        r &&
                        r.bonusAny === "Yes" &&
                        r.bonusDetails &&
                        r.bonusDetails.length > 0
                    ) {

                        var sortedBonus = r.bonusDetails
                            .slice()
                            .sort(function (a, b) {
                                return (
                                    (a.minimumStudents || a.totalStudents || 0) -
                                    (b.minimumStudents || b.totalStudents || 0)
                                );
                            });

                        return (
                            <div>
                                {sortedBonus.map(function (b, i) {
                                    return (
                                        <div key={i}>
                                            {formatBonus(b)}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    }

                    return "N/A";
                }
            },
            // {
            //     title: "Bonus Details",
            //     render: function (r) {

            //         if (!r || r.bonusAny !== "Yes") {
            //             return "N/A";
            //         }

            //         function getStudentRange(b) {
            //             if (b.minimumStudents || b.maximumStudents) {
            //                 return (b.minimumStudents || 0) + "-" + (b.maximumStudents || "∞");
            //             }
            //             if (b.totalStudents) {
            //                 return "0-" + b.totalStudents;
            //             }
            //             return "N/A";
            //         }

            //         function formatBonus(b) {
            //             return (
            //                 getStudentRange(b) +
            //                 " : " +
            //                 b.bonus +
            //                 (b.commissionType === "percentage" ? " %" : "")
            //             );
            //         }

            //         // ✅ CASE 1: commDetails exists
            //         if (r && r.commDetails && r.commDetails.length > 0) {

            //             var sortedComm = r.commDetails.slice().sort(function (a, b) {
            //                 return (a.term || 0) - (b.term || 0);
            //             });

            //             // ✅ Filter only those having bonusDetails
            //             var validTerms = sortedComm.filter(function (item) {
            //                 return item && item.bonusDetails && item.bonusDetails.length > 0;
            //             });

            //             // ❌ If none valid → DON'T fallback, directly N/A
            //             if (validTerms.length === 0) {
            //                 return "N/A";
            //             }

            //             return (
            //                 <div>
            //                     {validTerms.map(function (item, index) {

            //                         var sortedBonus = item.bonusDetails.slice().sort(function (a, b) {
            //                             return (
            //                                 (a.minimumStudents || a.totalStudents || 0) -
            //                                 (b.minimumStudents || b.totalStudents || 0)
            //                             );
            //                         });

            //                         return (
            //                             <div key={index}>
            //                                 <b>{"T" + (item.term || index + 1)}</b>

            //                                 {sortedBonus.map(function (b, i) {
            //                                     return (
            //                                         <div key={i} style={{ marginLeft: 10 }}>
            //                                             {formatBonus(b)}
            //                                         </div>
            //                                     );
            //                                 })}
            //                             </div>
            //                         );
            //                     })}
            //                 </div>
            //             );
            //         }

            //         // ✅ CASE 2: fallback to root bonusDetails ONLY if commDetails not present
            //         if (r && (!r.commDetails || r.commDetails.length === 0) && r.bonusDetails && r.bonusDetails.length > 0) {

            //             var sortedBonus = r.bonusDetails.slice().sort(function (a, b) {
            //                 return (
            //                     (a.minimumStudents || a.totalStudents || 0) -
            //                     (b.minimumStudents || b.totalStudents || 0)
            //                 );
            //             });

            //             return (
            //                 <div>
            //                     {sortedBonus.map(function (b, i) {
            //                         return (
            //                             <div key={i}>
            //                                 {formatBonus(b)}
            //                             </div>
            //                         );
            //                     })}
            //                 </div>
            //             );
            //         }

            //         // ✅ DEFAULT
            //         return "N/A";
            //     }
            // },
            // {
            //     title: "Bonus Details",
            //     render: function (r) {

            //         // ✅ FIRST PRIORITY: commDetails bonus
            //         if (r.commDetails && r.commDetails.length > 0) {
            //             return (
            //                 <div>
            //                     {r.commDetails.map(function (item, index) {

            //                         if (!item.bonusDetails || item.bonusDetails.length === 0) {
            //                             return (
            //                                 <div key={index}>
            //                                     {"T" + (item.term || index + 1) + ": N/A"}
            //                                 </div>
            //                             );
            //                         }

            //                         return (
            //                             <div key={index}>
            //                                 <b>{"T" + (item.term || index + 1)}</b>
            //                                 {item.bonusDetails.map(function (b, i) {
            //                                     return (
            //                                         <div key={i} style={{ marginLeft: 10 }}>
            //                                             {`${b.minimumStudents}-${b.maximumStudents || b.totalStudents || '∞'} : ${b.bonus} ${b.commissionType === 'percantage' ? '%' : ''}`}
            //                                         </div>
            //                                     );
            //                                 })}
            //                             </div>
            //                         );
            //                     })}
            //                 </div>
            //             );
            //         }

            //         // ✅ FALLBACK: root bonusDetails
            //         if (r && (!r.commDetails || r.commDetails.length === 0) && r.bonusDetails && r.bonusDetails.length > 0) {
            //             return (
            //                 <div>
            //                     {r.bonusDetails.map(function (b, i) {
            //                         return (
            //                             <div key={i}>
            //                                 {`${b.minimumStudents}-${b.maximumStudents || '∞'} : ${b.bonus} ${b.commissionType === 'percantage' ? '%' : ''}`}
            //                             </div>
            //                         );
            //                     })}
            //                 </div>
            //             );
            //         }

            //         return "N/A";
            //     }
            // },
            {
                title: "Full Agreement",
                width: 120,
                render: r => {
                    if (r.paymentUpload && r.paymentUpload.length) {
                        return (
                            <Button
                                icon="eye"
                                onClick={() => this.openAgreement(r.paymentUpload)}
                            />
                        );
                    }
                    return "NA";
                }
            },
            {
                title: "Commission Page",
                width: 120,
                render: r => {
                    if (
                        r.paymentUploadCommissionPage &&
                        r.paymentUploadCommissionPage.length
                    ) {
                        return (
                            <Button
                                icon="eye"
                                onClick={() =>
                                    this.openAgreement(r.paymentUploadCommissionPage)
                                }
                            />
                        );
                    }
                    return "NA";
                }
            },
            {
                title: "Course Levels",
                dataIndex: "selectedLevels",
                key: "selectedLevels",
                render: function (levels) {
                    if (!levels || !levels.length) return "-";

                    return levels.join(", ");
                }
            },
            {
                title: "Campuses",
                dataIndex: "selectedCampus",
                key: "selectedCampus",
                render: function (campus) {
                    if (!campus || !campus.length) return "-";

                    return campus.join(", ");
                }
            },
            {
                title: "Created / Updated By",
                key: "userAudit",

                render: function (text, r) {

                    const user = (r && r.updatedByUser) || (r && r.createdByUser);

                    if (!user) return "-";

                    const name = user.name || "-";

                    let time = null;

                    // ✅ HANDLE ALL DATE FORMATS
                    if (user.time) {
                        if (typeof user.time === "string") {
                            time = new Date(user.time);
                        }
                        else if (user.time.$date && user.time.$date.$numberLong) {
                            time = new Date(parseInt(user.time.$date.$numberLong));
                        }
                        else if (user.time.$date) {
                            time = new Date(user.time.$date);
                        }
                        else {
                            time = new Date(user.time);
                        }
                    }

                    const formattedDate = time
                        ? time.toLocaleDateString() + " " + time.toLocaleTimeString()
                        : "-";

                    return (
                        <div>
                            <div>{name}</div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                                {formattedDate}
                            </div>
                        </div>
                    );
                },

                // ✅ FILTER UI
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <RangePicker
                            showTime
                            style={{ marginBottom: 8, display: "block" }}
                            value={selectedKeys[0] || []}
                            onChange={(dates) => {
                                setSelectedKeys(dates ? [dates] : []);
                            }}
                        />

                        <Button
                            type="primary"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                            onClick={() => {
                                confirm();

                                // ✅ SAFE reload (no optional chaining)
                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Filter
                        </Button>

                        <Button
                            size="small"
                            style={{ width: 90 }}
                            onClick={() => {
                                clearFilters();

                                // ✅ SAFE reload after reset
                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Reset
                        </Button>
                    </div>
                ),

                filterIcon: function (filtered) {
                    return (
                        <Icon
                            type="calendar"
                            style={{ color: filtered ? "#1890ff" : undefined }}
                        />
                    );
                }
            }
            // {
            //     title: "Created / Updated By",
            //     key: "userAudit",
            //     render: function (r) {
            //         const user = r && r.updatedByUser || r && r.createdByUser;

            //         if (!user) return "-";

            //         const name = user.name || "-";
            //         const time = user.time ? new Date(user.time) : null;

            //         const formattedDate = time
            //             ? time.toLocaleDateString() + " " + time.toLocaleTimeString()
            //             : "-";

            //         return (
            //             <div>
            //                 <div>{name}</div>
            //                 <div style={{ fontSize: 12, color: "#888" }}>
            //                     {formattedDate}
            //                 </div>
            //             </div>
            //         );
            //     },

            //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            //         <div style={{ padding: 8 }}>
            //             <RangePicker
            //                 showTime
            //                 style={{ marginBottom: 8, display: "block" }}
            //                 onChange={(dates) => {
            //                     setSelectedKeys(dates ? [dates] : []);
            //                 }}
            //             />

            //             <Button
            //                 type="primary"
            //                 size="small"
            //                 style={{ width: 90, marginRight: 8 }}
            //                 onClick={() => confirm()}
            //             >
            //                 Filter
            //             </Button>

            //             <Button
            //                 size="small"
            //                 style={{ width: 90 }}
            //                 onClick={() => clearFilters()}
            //             >
            //                 Reset
            //             </Button>
            //         </div>
            //     ),

            //     filterIcon: filtered => (
            //         <Icon type="calendar" style={{ color: filtered ? "#1890ff" : undefined }} />
            //     ),

            //     onFilter: (value, record) => {
            //         if (!value || value.length !== 2) return true;

            //         const user = record.updatedByUser || record.createdByUser;
            //         if (!user || !user.time) return false;

            //         const recordDate = new Date(user.time).getTime();

            //         const start = value[0].startOf("day").valueOf();
            //         const end = value[1].endOf("day").valueOf();

            //         return recordDate >= start && recordDate <= end;
            //     }
            // }
        ];
        return (
            <Drawer
                title={
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>
                            {icon || <Icon type="profile" />} {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={visible}
                width={1200}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                {showAgreementDrawer && (
                    <ShowUniversityAgreement
                        record={agreementRecord}
                        onClose={this.closeAgreement}
                    />
                )}

                <TableComp
                    columns={columns}
                    ref={this.table}
                    // dataSource={arr}
                    apiRequest={this.apiRequest}
                    loading={loading}
                    rowKey={record => record._id}
                    extraProps={{ scroll: { x: 1900 } }}
                    pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50"]
                    }}
                />
            </Drawer>
        );
    }
}

export default connect()(UniversityCommApprovalDrawer);
